import { useQuery } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import type { UserListFilters, UserListResponse } from "../../../types/userInvite";

const fetchUsers = async (companyId: number, filters: UserListFilters): Promise<UserListResponse> => {
  const params: Record<string, string | string[] | number> = {};
  if (filters.status && filters.status.length > 0) {
    params["status[]"] = filters.status;
  }
  if (filters.search) {
    params.search = filters.search;
  }
  if (filters.sort) {
    params.sort = filters.sort;
  }
  if (filters.page) {
    params.page = filters.page;
  }
  const response = await apiV1.get<UserListResponse>(`companies/${companyId}/users`, { params });
  return response.data;
};

export const useUsersQuery = (filters: UserListFilters = {}) => {
  const companyId = useCurrentCompanyId();

  return useQuery<UserListResponse, Error>({
    queryKey: ["users", companyId, filters],
    queryFn: () => fetchUsers(companyId!, filters),
    enabled: companyId != null,
  });
};
